import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'
import { DayHour } from '../datetime/DayHour'
import { WeekDay } from '../datetime/WeekDay'
import { MonthDay } from '../datetime/MonthDay'

export enum TaskRecurrencePeriodId {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
}

export class TaskRecurrencePeriod extends Codebook<TaskRecurrencePeriodId> {
  static readonly DAY = new TaskRecurrencePeriod(TaskRecurrencePeriodId.DAY, () => $t('Day'))
  static readonly WEEK = new TaskRecurrencePeriod(TaskRecurrencePeriodId.WEEK, () => $t('Week'))
  static readonly MONTH = new TaskRecurrencePeriod(TaskRecurrencePeriodId.MONTH, () => $t('Month'))

  private constructor(
    id: TaskRecurrencePeriodId,
    public readonly name: () => string,
  ) {
    super(id)
  }

  getValues(): ValueCodebook[] {
    switch (this.id) {
      case TaskRecurrencePeriodId.DAY:
        return DayHour.all()

      case TaskRecurrencePeriodId.WEEK:
        return WeekDay.all()

      case TaskRecurrencePeriodId.MONTH:
        return MonthDay.all()

      default:
        throw new Error('Unhandled recurrence period')
    }
  }
}

type ValueCodebook = Codebook<number> & { name: () => string }
